function check_msisdn(number) {
	var start = 0;
	var stripped = ["0", "+"];
	while (stripped.indexOf(number[start]) !== -1) {
		start += 1;
	}

	number = number.substring(start);
	if (isNaN(number)) {
		number = null;
	}
	else if (number.length === 9) {
		number = "00420" + number;
	}
	else if (number.length === 12) {
		number = "00" + number;
	}
	else if (number.length !== 14) {
		number = null;
	}
	// length 14 chars, OK
	return number;
}

function check_contact_phone(number) {
	// pokud začíná + stripni ho

	if (number.startsWith("+")) {
		number = number.substring(1);
	}
	// pokud začíná 00 stripni ho
	if (number.startsWith("00")) {
		number = number.substring(2);
	}
	// pokud obsahuje číslo mezery, tak je odstraň
	number = number.replace(/\s/g, "");

	if (isNaN(number)) {
		number = null;
	}
	else if (number.length === 9) {
		// pokud je 9 znaků je to OK jen přidám 420
		number = "420" + number;
	}
	else if (number.length === 12) {
		// pokud je 12 znaků zkonttroluj prefix na český
		if (number.startsWith("420")) {
			// pokud začíná na 420 je to OK

		}
		else {
			// pokud nezačíná na 420 je to špatně
			number = null;
		}
	} else {
		// pokud není 9 nebo 12 znaků je to špatně
		number = null;
	}
	return number;
}


var handleAddressChange = function (ev) {

	ev.preventDefault();
	var form = ev.currentTarget;

	var message_field = form.querySelector(".settings_message");
	clear_message(message_field);
	var address_type = form.address_type.value;
	// kontrola jestli je validní
	if (!is_address_valid(form, address_type)) {
		// pokud ne kašlu na to
		// console.log("Address is not valid");
		return false;
	}

	// teď data
	var qry_args = {
		address_type: address_type
	};

	// projdu pole co jsou součástí téhle adresy a uložím si jejich hodnotu
	//  už je nekontroluji prootže už zkontrolavané jsou
	var err = false;
	for (var i = 0; i < form.elements.length; i++) {
		var field = form.elements[i];
		if (field.classList.contains('js-addres_type-' + address_type)) {
			var value = field.type == 'checkbox' ? field.checked : $(field).val();
			if (value) {
				if (typeof (field.dataset.field_name) === 'undefined') {
					console.warn("Missing dataset fieldname on", field);
					return false;
				}
				// telefon na rozdíl od jiných polí má normalizaci.
				if (field.dataset.field_name == 'phone') {
					if (check_msisdn(value) == null) {
						console.warn("Phone number is invalid");
						mark_invalid(field, "div.form-group", "invalid_text");
						err = true;
					}
				}
				// Asi to je špatně -> stripni _address
				qry_args[field.dataset.field_name] = value;
			}
		}
	}

	if (err) { return false; }

	// v psc zahazujeme mezery
	if (qry_args.zip) {
		qry_args.zip = qry_args.zip.replace(/\s/g, "");
	}

	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		// readyState OPENED
		if (req.readyState === 1) {
			document.body.classList.add("loading");
		}
		// readyState HEADERS_RECEIVED
		else if (req.readyState === 2) {
			document.body.classList.remove("loading");
		}
		else if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var resp_data = JSON.parse(req.responseText);
				if (resp_data["status"] === 200) {
					show_message(message_field, "Změněno", "success");
					var prev_val_was_null = false;
					$.each($("input[name=" + resp_data["address_type"] + "_address_id" + "]"), function () {
						if (!$(this).val()) {
							prev_val_was_null = true;
						}
						$(this).val(resp_data["address_id"]);
					});

					// update udaju pri navratu z popupu v kosiku 2. krok
					if ($('.js--shipping_address').length > 0 || $('.js--facturation_address').length > 0) {
						addressChangedInPopupCart(resp_data["address_id"], resp_data["address_type"], qry_args, prev_val_was_null);
						setTimeout(function () {
							$('#modal_edit_' + resp_data["address_type"] + '_address').modal('hide');
							var message_field = form.querySelector(".settings_message");
							clear_message(message_field);
						}, 1000);
					}
				}
				else {
					// TODO
					show_message(message_field, resp_data["status_message"], "danger");
					alert(resp_data["status_message"]);
				}
			}
			else {
				alert("Chyba");
			}
		}
	};
	// console.log("Addres is ok -> gonna ssave and close modal");
	req.open("POST", "/ajax/change_address", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

var handleNewsletterChange = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var state = Boolean(tgt.checked);
	var qry_args = {
		"enabled": state,
	};
	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {
					// newsletter se změnil OK
				} else {
					tgt.checked = !state;
					alert(req_data["status_message"]);
				}
			}
			else {
				tgt.checked = !state;
				alert("Chyba");
			}
		}
	};

	req.open("POST", "/ajax/change_newsletter", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

var handleNotificationChange = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var state = Boolean(tgt.checked);
	var qry_args = {
		"enabled": state,
	};
	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {
					// notifikace se změnily OK
				} else {
					tgt.checked = !state;
					alert(req_data["status_message"]);
				}
			}
			else {
				tgt.checked = !state;
				alert("Chyba");
			}
		}
	};

	req.open("POST", "/ajax/change_nt_notification", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

var handlePasswordChange = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var el_old = tgt.querySelector("input[name=old]");
	var old_passwd = el_old.value;
	var el_new = tgt.querySelector("input[name=new]");
	var passwd = el_new.value;
	var el_new2 = tgt.querySelector("input[name=new2]");
	var passwd2 = el_new2.value;
	var message_field = tgt.querySelector(".settings_message");

	unmark_invalid(el_old);
	unmark_invalid(el_new);
	unmark_invalid(el_new2);
	clear_message(message_field);

	if (!old_passwd) {
		mark_invalid(el_old);
		return false;
	}
	if (passwd.length < 8) {
		mark_invalid(el_new);
		return false;
	}
	if (passwd !== passwd2) {
		mark_invalid(el_new2);
		return false;
	}
	var qry_args = {
		"old_password": old_passwd,
		"password": passwd
	};
	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {
					// OK
					el_old.value = "";
					el_new.value = "";
					el_new2.value = "";
					show_message(message_field, "Změněno", "success");
					if (tgt.dataset.refresh == 'true') {
						location.href = location.protocol + '//' + location.host + location.pathname + location.search;

					}
				}
				else {
					show_message(message_field, req_data["status_message"], "danger");
				}
			}
			else {
				alert("Chyba");
			}
		}
	};

	req.open("POST", "/ajax/change_password", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

var handleIcoChange = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var el_ico = tgt.querySelector("input[name=ico]");
	if (!el_ico.dataset.valid) {
		return false;
	}
	var ico = el_ico.value;
	var message_field = tgt.querySelector(".settings_message");

	unmark_invalid(el_ico);
	clear_message(message_field);

	var qry_args = {
		"ico": ico
	};
	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {
					// OK
					show_message(message_field, "Změněno", "success");
					if (tgt.dataset.refresh == 'true') {
						location.href = location.protocol + '//' + location.host + location.pathname + location.search;

					}
				}
				else {
					show_message(message_field, req_data["status_message"], "danger");
				}
			}
			else {
				alert("Chyba");
			}
		}
	};

	req.open("POST", "/ajax/change_ico", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

var handleContactPhoneChange = function (ev) {
	ev.preventDefault();
	var tgt = ev.currentTarget;
	var el_phone = tgt.querySelector("input[name=msisdn]");
	var phone = el_phone.value;
	var message_field = tgt.querySelector(".settings_message");

	unmark_invalid(el_phone);
	clear_message(message_field);

	phone = check_contact_phone(phone);
	if (phone === null) {
		mark_invalid(el_phone);
		return false;
	}

	var qry_args = {
		"msisdn": phone
	};
	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status === 200) {
				var req_data = JSON.parse(req.responseText);
				if (req_data["status"] === 200) {
					show_message(message_field, "Změněno", "success");
				}
				else {
					show_message(message_field, req_data["status_message"], "danger");
				}
			}
			else {
				alert("Chyba");
			}
		}
	};

	req.open("POST", "/ajax/change_contact_phone", true);
	req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	req.send(serialize(qry_args));
	return false;
};

document.addEventListener("DOMContentLoaded", function (event) {
	var newsletter_switches = document.querySelectorAll("input[name=newsletter_switch]");
	if (newsletter_switches) {
		[].forEach.call(newsletter_switches, function (item) {
			item.addEventListener("change", handleNewsletterChange);
		});
	}

	var notification_switches = document.querySelectorAll("input[name=notification_switch]");
	if (notification_switches) {
		[].forEach.call(notification_switches, function (item) {
			item.addEventListener("change", handleNotificationChange);
		});
	}

	var password_change_forms = document.querySelectorAll("form[name=change_password]");
	if (password_change_forms) {
		[].forEach.call(password_change_forms, function (item) {
			item.addEventListener("submit", handlePasswordChange);
		});
	}

	var address_change_forms = document.querySelectorAll("form[name=change_address]");
	if (address_change_forms) {
		[].forEach.call(address_change_forms, function (form) {
			form.addEventListener("submit", handleAddressChange);
		});
	}

	var ico_change_forms = document.querySelectorAll("form[name=change_ico]");
	if (ico_change_forms) {
		[].forEach.call(ico_change_forms, function (item) {
			item.addEventListener("submit", handleIcoChange);
			item.ico.addEventListener("change", function (evt) {
				var icoEl = item.ico;
				validateFormIco(icoEl);
				return true;
			});
		});
	}
	var contact_phone_change_forms = document.querySelectorAll("form[name=change_msisdn]");
	if (contact_phone_change_forms) {
		[].forEach.call(contact_phone_change_forms, function (item) {
			item.addEventListener("submit", handleContactPhoneChange);
			item.msisdn.addEventListener("change", function (evt) {
				var phoneEl = item.msisdn;
				var phone = check_contact_phone(phoneEl.value);
				if (phone === null) {
					mark_invalid(phoneEl);
				} else {
					unmark_invalid(phoneEl);
				}
				return true;
			});
		});
	}

});
